import { NewSideBarItem } from './NewSideBarItem';
import { useOutletContext } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';
import { List } from '@mui/material';
import {
  Home as HomeIcon,
  AccessTimeFilled as AccessTimeFilledIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  ManageAccounts as ManageAccountsIcon,
  Try as TryIcon,
} from '@mui/icons-material';
import TaskIcon from '@mui/icons-material/Task';
import Badge from '@mui/material/Badge';
import { useRequestNotification } from '../../providers/RequestNotificationContext';

export const NewSideBarList = (props) => {
  const [empId] = useOutletContext();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const { requestCount, setRequestCount } = useRequestNotification();

  useEffect(() => {
    const loadData = async () => {
      try {
        // Fetch employee
        const empRes = await fetch(apiUrl('/employee/' + empId), {
          method: 'GET',
          credentials: 'include',
        });
        const empData = await empRes.json();
        const role = empData.data.role;

        const superAdmin = role === 'SUPER_ADMIN';
        const admin = role === 'ADMIN';

        setIsSuperAdmin(superAdmin);
        setIsAdmin(admin);

        // If super admin, fetch pending request count
        if (superAdmin) {
          const reqRes = await fetch(
            apiUrl('/eis/empeditrequest/pending/count'),
            {
              method: 'GET',
              credentials: 'include',
            }
          );

          const reqData = await reqRes.json();
          setRequestCount(reqData.data);
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadData();
  }, [empId]);

  return (
    <List
      sx={{
        overflowY: 'auto',
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': {
          display: 'none', // Chrome, Safari, Edge
        },
        mb: 2,
      }}
    >
      <NewSideBarItem
        open={props.open}
        text={'Dashboard'}
        iconName={<HomeIcon />}
        selected={props.selectedPage === 0}
        route="/dashboard"
      />
      <NewSideBarItem
        open={props.open}
        text={'Timesheet'}
        iconName={<AccessTimeFilledIcon />}
        selected={props.selectedPage === 1}
        route="/timesheet"
      />
      <NewSideBarItem
        open={props.open}
        text={'Employees'}
        iconName={<PeopleIcon />}
        selected={props.selectedPage === 2}
        route="/employees"
      />
      <NewSideBarItem
        open={props.open}
        text={'Profile'}
        iconName={<PersonIcon />}
        selected={props.selectedPage === 3}
        route="/profile"
      />
      <NewSideBarItem
        open={props.open}
        text={'EPS Assistant'}
        iconName={<TryIcon />}
        selected={props.selectedPage === 6}
        route="/chatbot"
      />

      {(isAdmin || isSuperAdmin) && (
        <NewSideBarItem
          open={props.open}
          text={'Manage'}
          iconName={<ManageAccountsIcon />}
          selected={props.selectedPage === 4}
          route="/manage"
        />
      )}

      {isSuperAdmin && (
        <>
          <NewSideBarItem
            open={props.open}
            text={'Requests'}
            iconName={
              <Badge badgeContent={requestCount} color="error">
                <TaskIcon />
              </Badge>
            }
            selected={props.selectedPage === 5}
            route="/requests"
          />
        </>
      )}
    </List>
  );
};
